var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCloseError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "0myxx3vmma",
    d: "M9.333 0.94L8.393 0 4.667 3.727 0.94 0 0 0.94 3.727 4.667 0 8.393 0.94 9.333 4.667 5.607 8.393 9.333 9.333 8.393 5.607 4.667z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L16 0 16 16 0 16z",
    transform: "translate(-96 -486) translate(64 62) translate(32 101) translate(0 320) translate(0 3)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-96 -486) translate(64 62) translate(32 101) translate(0 320) translate(0 3) translate(3.333 3.333)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "bsuzhj0o3b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#0myxx3vmma"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    fillRule: "nonzero",
    xlinkHref: "#0myxx3vmma"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#DB1E5D",
    mask: "url(#bsuzhj0o3b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 16L16 16 16 0 0 0z",
    transform: "translate(-3.333 -3.333)"
  })))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCloseError);
export default __webpack_public_path__ + "static/media/icon-close-error.54e5ecad8847f257d4aba71ebcca2bc6.svg";
export { ForwardRef as ReactComponent };